import React, { useState } from "react";

import { faCircleXmark } from '@fortawesome/pro-light-svg-icons';

import {
  _AnimatedErrorMessage as AnimatedErrorMessage,
  _CloseButton as CloseButton
} from "./ErrorMessage.style";


const ErrorMessage = (error) => {
  const [show, setShow] = useState(error);

  return (
    <AnimatedErrorMessage show={show}>
      <span>{error.children}</span>
      <CloseButton
        icon={faCircleXmark}
        color="#fff"
        onClick={() => {
          setShow(false);
          window.location.reload();
        }}
      />
    </AnimatedErrorMessage>  
  );
}

export default ErrorMessage;